import _ from 'lodash';

function GameCtrl($rootScope, $scope, $state, $stateParams, $timeout, toastr, PlanService, UserService, AppContextService) {
  'ngInject';

  var vm = this;
  vm.appContext = AppContextService.context;
  var plans;
  vm.mode = 'list';
  vm.year = $stateParams.year;
  vm.month = $stateParams.month;


  vm.monthRanges = _.range(1, 13).map(num => ('0' + num).slice(-2));

  // 부상 상황 변경
  $scope.$watch('game.year', function (newVal, oldVal) {
    if (newVal) {
      vm.filterGames();
    }
  });

  $scope.$watch('game.month', function (newVal, oldVal) {
    if (newVal) {
      vm.filterGames();
    }
  });

  vm.filterGames = function () {

    var check = (vm.year && vm.month) || (!vm.year && !vm.month);

    if (!check) {
      console.log('check ERROR...', check);
      return;
    }
    var yearMonth = '';
    if (vm.year && vm.month) {
      yearMonth = vm.year + '.' + vm.month;
    }

    // console.log('filter....', yearMonth);
    // console.log('filter....', _.filter(plans, {type:'경기'}));
    if (yearMonth) {
      var items = _.filter(plans, function (p) {
        return p.type === '경기' && p.date.startsWith(yearMonth)
      });
      vm.items = _.orderBy(items, ['id'], ['desc']);
    } else {
      var items = _.filter(plans, { type: '경기' });
      vm.items = _.orderBy(items, ['id'], ['desc']);
    }
  }

  vm.setToday = function () {
    vm.year = new Date().toISOString().slice(0, 4);
    vm.month = new Date().toISOString().slice(5, 7);
  }

  vm.createGame = function () {
    vm.appContext.players.game.my_team.entryMain = [];
    vm.appContext.players.game.my_team.entryBackup = [];
    vm.appContext.players.game.oppo_team.entryMain = [];
    vm.appContext.players.game.oppo_team.entryBackup = [];

    var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    var localISOTime = (new Date(new Date() - tzoffset)).toISOString().slice(0, -5);
    var date = localISOTime.split("T")[0].split("-").join(".");
    var time = localISOTime.split("T")[1];
    // vm.appContext.gameDateTime = date + ' ' + time;
    // //vm.appContext.gameDateTime = '';

    vm.appContext.oppoTeam_id = '';

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      date: date,
      time: time
    };

    PlanService.setGame(data)
      .then(function (res) {
        $stateParams.game_id = res.data.game_id;
        $state.go('Service.gameDetail', { game_id: $stateParams.game_id, year: vm.year, month: vm.month })
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })







  }

  vm.remove = function (id) {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      game_id: id
    }
    PlanService.removeGame(data).then(function () {
      getGames();
    })
  }




  // var _planData = angular.copy(vm.planData);

  //     delete _planData.month;

  var getGames = function () {
    var planData = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      // month: '2017.09',
      show_team: 'B'
    };

    PlanService.plans(planData).then(function (res) {
      // console.log('All games', res);
      plans = res.data.plans;
      vm.filterGames();
    });
  };
  getGames();



  // vm.items = [
  //   { name: 'aaa' },
  //   { name: 'bbb' },
  //   { name: 'ccc' },
  // ]

  // // 날짜 변경
  // if ($stateParams.date) {
  //   $scope.$parent.base.commonData.date = $stateParams.date;
  //   // $scope.$parent.base.commonData.month = '2017.04';
  // }

  // // ViewModel
  // const vm = this;


  // //사용자관리 화면에서 미리 상대팀 선수를 선택한 경우에는 상대팀 정보에 정보를세팅하기 위한 변수
  // vm.selectedOppTeam = $rootScope.selectedOppTeam;
  // vm.oppPlayers = $scope.$parent.base.oppPlayers;

  // //현재 page명 세팅
  // $scope.$parent.base.pageStatus = 'recordGame';
  // $scope.initPage = function() {
  //   $scope.$parent.base.rejectPlayer();
  //   setPage();
  // }

  // $scope.displayGameResult = 'team';
  // function displayPlayerGameResult(args){
  //   $scope.displayGameResult = args.code;
  //   if($scope.displayGameResult === 'player'){
  //     vm.playerGameResultData = $scope.$parent.base.playerGameResultData;
  //     console.log('vm.playerGameResultData : ', vm.playerGameResultData);
  //     let user_id = +($scope.$parent.base.selectedPlayer.user_id);
  //     let playerGameResult = _.find(
  //       vm.playerGameResultData.players_game_result.per_user_data,
  //       {
  //         'user_id': user_id
  //       }
  //     );
  //     // vm.playerGameResultData = $scope.$parent.base.playerGameResultData;
  //     // console.log('vm.playerGameResultData : ', vm.playerGameResultData);
  //     // let playerGameResult = vm.playerGameResultData.players_game_result.per_user_data;
  //     // let idx;
  //     // let user_id = $scope.$parent.base.selectedPlayer.user_id;
  //     // for(idx = 0;idx < playerGameResult.length;idx++){
  //     //   if(playerGameResult[idx].user_id == user_id){
  //     //     break;
  //     //   }else{
  //     //     continue;
  //     //   }
  //     // }
  //     // vm.playerGameResult = playerGameResult[idx];
  //     vm.playerGameResult = playerGameResult;
  //     let name = $scope.$parent.base.selectedPlayer.name;
  //     $scope.selectedPlayerName = `- ${name}`;
  //   } else if($scope.displayGameResult === 'team') {
  //     vm.playerGameResult = {};
  //     $scope.selectedPlayerName = '';
  //   } else if($scope.displayGameResult === 'players') {
  //     if ($scope.$parent.base.selectPlayerList.length === 0) {
  //       vm.playerGameResult = {};
  //     } else {
  //       vm.playerGameResult = {
  //         goals: 0,
  //         lost_points: 0,
  //         assists: 0,
  //         fouls: 0,
  //         warnings: 0,
  //         sending_offs: 0
  //       };

  //       // 아래의 코드는 $scope.$parent.base.playerGameResultData 에 데이터가 아직 들어오지 않았을 때 문제가 됨
  //       // 수정이 필요함
  //       vm.playerGameResultData = $scope.$parent.base.playerGameResultData;

  //       for (let i = 0; i < $scope.$parent.base.selectPlayerList.length; i++) {
  //         let obj = _.find(
  //           vm.playerGameResultData.players_game_result.per_user_data,
  //           {
  //             'user_id': +$scope.$parent.base.selectPlayerList[i]
  //           }
  //         );

  //         if (obj) {
  //           vm.playerGameResult.goals = vm.playerGameResult.goals + obj.goals;
  //           vm.playerGameResult.lost_points = vm.playerGameResult.lost_points + obj.lost_points;
  //           vm.playerGameResult.assists = vm.playerGameResult.assists + obj.assists;
  //           vm.playerGameResult.fouls = vm.playerGameResult.fouls + obj.fouls;
  //           vm.playerGameResult.warnings = vm.playerGameResult.warnings + obj.warnings;
  //           vm.playerGameResult.sending_offs = vm.playerGameResult.sending_offs + obj.sending_offs;
  //         }
  //       }
  //     }
  //   }
  // }


  // /**
  //  * API 호출 시 parameter 로 사용할 변수
  //  */
  // vm.setGameData = $scope.$parent.base.setGameData;
  // vm.gameInfoData = $scope.$parent.base.gameInfoData;
  // vm.gameResultData = $scope.$parent.base.gameResultData;
  // vm.gameMetaData = $scope.$parent.base.gameMetaData;
  // vm.setMurlData = $scope.$parent.base.setMurlData;
  // vm.removeMurlData = $scope.$parent.base.removeMurlData;

  // $scope.$on('childPageLoading', function(e) {
  //   // $scope.$emit('pingBack', $scope.initPage());
  //   setPage();
  // });

  // //팀화면에서 개인별 경기결과를 화면에 보여준다.
  // $scope.$on('playerGameResult', function(e, args){
  //   if(!vm.gameInfoData.game_id){
  //     return;
  //   }
  //   displayPlayerGameResult(args);
  // });

  // //게임기록 화면 데이터 세팅
  // function setPage(){
  //   /**
  //    * API 호출 시 parameter 로 사용할 변수
  //    */
  //   vm.setGameData = $scope.$parent.base.setGameData;
  //   vm.gameInfoData = $scope.$parent.base.gameInfoData;
  //   vm.gameResultData = $scope.$parent.base.gameResultData;
  //   vm.gameMetaData = $scope.$parent.base.gameMetaData;
  //   vm.setMurlData = $scope.$parent.base.setMurlData;
  //   vm.removeMurlData = $scope.$parent.base.removeMurlData;

  //   /**
  //    *  상대팀 선택하기
  //    */
  //   vm.teams1 = null; // 팀 1단계 목록
  //   vm.selectedTeam1 = null;
  //   vm.teams2 = null; // 팀 2단계 목록
  //   vm.selectedTeam2 = null;
  //   vm.teams3 = null; // 팀 3단계 목록
  //   vm.selectedTeam3 = null;
  //   vm.team4 = null; //팀 4단계 목록
  //   vm.selectedTeam4 = null;

  //   // 경기 정보 입력에 필요한 데이터 조회
  //   PlanService.getGameMeta().then(function(data) {
  //     vm.gameMetaData.gtypes = data.gtypes;
  //     vm.gameMetaData.lawns = data.lawns;

  //     if(!vm.gameInfoData.game_id){
  //       vm.gameInfoData.gtype = data.gtypes[0];
  //       vm.gameInfoData.lawn = data.lawns[0];
  //     }else{
  //       let gtypeIdx = vm.gameInfoData.gtype_id;
  //       let lawnIdx = vm.gameInfoData.lawn_id;

  //       vm.gameInfoData.gtype = {id: vm.gameInfoData.gtype_id, name: vm.gameInfoData.gtype_name};
  //       vm.gameInfoData.lawn = {id: vm.gameInfoData.lawn_id, name: vm.gameInfoData.lawn_name};
  //     }
  //   });

  //   // 초기 경기장 목록 불러오기
  //   vm.stadiums1 = null;
  //   vm.selectedStadium1 = null;
  //   vm.stadiums2 = null;
  //   vm.selectedStadium2 = null;
  //   PlanService.getStadiums().then(function(data) {
  //     vm.stadiums1 = data.list;
  //     if(!vm.gameInfoData.game_id){
  //       vm.selectedStadium1 = vm.stadiums1[0];
  //       if (vm.stadiums1[0].is_last) {
  //         vm.gameInfoData.stadium_id = vm.stadiums1[0].id;
  //       }
  //     }else{
  //       let idx = _.findIndex(
  //                               vm.stadiums1,
  //                               {
  //                                 'id': vm.gameInfoData.parent_stadium_id
  //                               }
  //                             );
  //       vm.selectedStadium1 = vm.stadiums1[idx];
  //     }
  //   });

  //   // 초기 경기 명칭 목록 불러오기
  //   vm.parentGnames = null;
  //   vm.selectedParentGname = null;
  //   vm.gnames = null;
  //   vm.selectedGname = null;
  //   PlanService.getGnames().then(function(data) {
  //     vm.parentGnames = data.list;
  //     vm.selectedParentGname = vm.parentGnames[0];
  //   });

  //   // 초기 대륙 목록 불러오기
  //   vm.continents = null; // 대륙 목록
  //   vm.selectedContinent = null;
  //   vm.selectedCountry = null;
  //   UserService.getCountries().then(function(data) {
  //     vm.continents = data.list;
  //     if(vm.oppPlayers){
  //       vm.selectedContinent = vm.selectedOppTeam.continent;
  //     }else{
  //       vm.selectedContinent = vm.continents[0];
  //     }
  //   });

  //   // 초기 팀 목록 불러오기
  //   PlanService.getTeams().then(function(data) {
  //     console.log('vm.gameInfoData : ', vm.gameInfoData)
  //     vm.teams1 = data.list;
  //     if(!vm.gameInfoData.game_id){
  //       vm.selectedTeam1 = vm.teams1[0];
  //     }else{
  //       let idx = _.findIndex(
  //                               vm.teams1,
  //                               {
  //                                 'id': vm.gameInfoData.parent_team_id
  //                               }
  //                             );
  //       vm.selectedTeam1 = vm.teams1[idx];
  //     }
  //   });
  // }

  // // 경기 명칭 1단계 변경
  // $scope.$watch('recordGame.selectedParentGname', function(newVal, oldVal) {
  //   if (newVal) {
  //     PlanService.getGnames({ parent_id: newVal.id }).then(function(data) {
  //       $scope.$apply(function() {
  //         vm.gnames = data.list;
  //         vm.selectedGname = vm.gnames[0];
  //       });
  //     });
  //   }
  // });

  // // 경기 명칭 2단계 변경
  // $scope.$watch('recordGame.selectedGname', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.gameInfoData.gname_id = newVal.id;
  //   }
  // });

  // // 대륙 변경
  // $scope.$watch('recordGame.selectedContinent', function(newVal, oldVal) {
  //   if (newVal && !newVal.is_last) {
  //     UserService.getCountries({ parent_id: newVal.id }).then(function(data) {
  //       console.log('countires : ', data);
  //       $scope.$apply(function() {
  //         vm.countries = data.list;
  //         if(vm.oppPlayers){
  //           vm.selectedCountry = vm.selectedOppTeam.country;
  //         }else{
  //           vm.selectedCountry = vm.countries[0];
  //         }
  //       });
  //     });
  //   }
  // });

  // // 국가 변경
  // $scope.$watch('recordGame.selectedTeamCountry', function(newVal, oldVal) {
  //   if (newVal) {
  //     // 초기 팀 목록 불러오기
  //     UserService.getTeams({ country_id: newVal.id }).then(function(data) {
  //       $scope.$apply(function() {
  //         vm.teams1 = data.list;
  //         if(vm.oppPlayers){
  //           vm.selectedTeam1 = vm.selectedOppTeam.selectedTeam1;
  //         }else{
  //           vm.selectedTeam1 = vm.teams1[0];
  //         }
  //       });
  //     });
  //   }
  // });

  // // 팀 1단계 변경
  // $scope.$watch('recordGame.selectedTeam1', function(newVal, oldVal) {
  //   if (newVal && !newVal.is_last) {
  //     UserService.getTeams({ parent_id: newVal.id }).then(function(data) {
  //       $scope.$apply(function() {
  //         vm.teams2 = data.list;
  //         if(vm.oppPlayers){
  //           vm.selectedTeam2 = vm.selectedOppTeam.selectedTeam2;
  //         }else{
  //           vm.selectedTeam2 = vm.teams2[0];
  //         }
  //       });
  //     });
  //   } else {
  //     if (newVal) {
  //       vm.gameInfoData.team_id = newVal.id;
  //       vm.opp_team_name = newVal.name;
  //     }
  //     vm.teams2 = null;
  //     vm.teams3 = null;
  //   }
  // });

  // // 팀 2단계 변경
  // $scope.$watch('recordGame.selectedTeam2', function(newVal, oldVal) {
  //   vm.selectedTeam3 = null;
  //   vm.selectedTeam4 = null;

  //   if (newVal && !newVal.is_last) {
  //     UserService.getTeams({ parent_id: newVal.id }).then(function(data) {
  //       $scope.$apply(function() {
  //         vm.teams3 = data.list;
  //         if(vm.oppPlayers){
  //           vm.selectedTeam3 = vm.selectedOppTeam.selectedTeam3;
  //         }else{
  //           vm.selectedTeam3 = vm.teams3[0];
  //         }
  //       });
  //     });
  //   } else {
  //     if (newVal) {
  //       vm.gameInfoData.team_id = newVal.id;
  //       vm.opp_team_name = newVal.name;
  //     }
  //     vm.teams3 = null;
  //   }
  // });

  // // 팀 3단계 변경
  // $scope.$watch('recordGame.selectedTeam3', function(newVal, oldVal){
  //   console.log(newVal);
  //   if (newVal && !newVal.is_last) {
  //     UserService.getTeams({ parent_id: newVal.id }).then(function(data) {
  //       $scope.$apply(function() {
  //         vm.teams4 = data.list;
  //         if(vm.oppPlayers){
  //           vm.selectedTeam4 = vm.selectedOppTeam.selectedTeam4;
  //         }else{
  //           vm.selectedTeam4 = vm.teams4[0];
  //         }
  //       });
  //     });
  //   } else {
  //     if (newVal) {
  //       vm.gameInfoData.team_id = newVal.id;
  //       vm.opp_team_name = newVal.name;
  //     }
  //     vm.teams4 = null;
  //   }
  // });

  // // 팀 4단계 변경
  // $scope.$watch('recordGame.selectedTeam4', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.gameInfoData.team_id = newVal.id;
  //     vm.opp_team_name = newVal.name;
  //   }
  // });
  // /**
  //  * select 변경시 값 적용
  //  */
  // // 경기상황 - 구분 변경
  // $scope.$watch('recordGame.gameInfoData.gtype', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.gameInfoData.gtype_id = newVal.id;
  //   }
  // });

  // // 경기상황 - 잔디 변경
  // $scope.$watch('recordGame.gameInfoData.lawn', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.gameInfoData.lawn_id = newVal.id;
  //   }
  // });

  // // 경기장 1단계 변경
  // $scope.$watch('recordGame.selectedStadium1', function(newVal, oldVal) {
  //   if (newVal && !newVal.is_last) {
  //     PlanService.getStadiums({ parent_id: newVal.id }).then(function(data) {
  //       $scope.$apply(function() {
  //         vm.stadiums2 = data.list;
  //         if(!vm.gameInfoData.game_id){
  //           vm.selectedStadium2 = vm.stadiums2[0];
  //         }else{
  //           let idx = _.findIndex(
  //                                   vm.stadiums2,
  //                                   {
  //                                     'id': vm.gameInfoData.stadium_id
  //                                   }
  //                                 );
  //           vm.selectedStadium2 = vm.stadiums2[idx];
  //         }
  //       });
  //     });
  //   }
  // });

  // // 경기장 2단계 변경
  // $scope.$watch('recordGame.selectedStadium2', function(newVal, oldVal) {
  //   if (newVal) {
  //     vm.gameInfoData.stadium_id = newVal.id;

  //     // 날씨 정보 불러오기
  //     vm.getWeather();
  //   }
  // });

  // /**
  //  * 동작 기능
  //  */
  // // 날씨 정보 불러오기
  // vm.getWeather = function() {
  //   const address = vm.selectedStadium1.name + ' ' + vm.selectedStadium2.name;
  //   let lat;
  //   let lng;
  //   // 지오코딩
  //   console.log('address **** ',address);
  //   PlanService.geocode(address).then(function(data) {
  //     if (data.results && data.results.length) {
  //       lat = data.results[0].geometry.location.lat;
  //       lng = data.results[0].geometry.location.lng;

  //       let gridObj = PlanService.dfsXyConv('toXY', lat, lng);

  //       // 기상청 날씨정보 가져오기
  //       PlanService.getWeather(gridObj.nx, gridObj.ny).then(function(data) {
  //         let items = data.response.body.items.item;

  //         // 하늘상태(날씨)
  //         let sky = _.find(items, {
  //           category: 'SKY'
  //         });

  //         if (sky) {
  //           if (sky.obsrValue == 1) {
  //             vm.gameInfoData.weather = '맑음';
  //           } else if (sky.obsrValue == 2) {
  //             vm.gameInfoData.weather = '구름조금';
  //           } else if (sky.obsrValue == 3) {
  //             vm.gameInfoData.weather = '구름많음';
  //           } else if (sky.obsrValue == 4) {
  //             vm.gameInfoData.weather = '흐림';
  //           }
  //         }

  //         // 습도
  //         let reh = _.find(items, {
  //           category: 'REH'
  //         });
  //         if (reh) {
  //           vm.gameInfoData.humidity = reh.obsrValue;
  //         }

  //         // 기온
  //         let t1h = _.find(items, {
  //           category: 'T1H'
  //         });
  //         if (t1h) {
  //           vm.gameInfoData.temperature = t1h.obsrValue;
  //         }

  //         // 풍속(바람)
  //         let wsd = _.find(items, {
  //           category: 'WSD'
  //         });
  //         if (wsd) {
  //           vm.gameInfoData.wind = wsd.obsrValue;
  //         }
  //       });

  //       // 미세먼지 정보 가져오기
  //       PlanService.getFineDust(vm.selectedStadium1.name).then(function(data) {
  //         let findDustData = data.list[0];

  //         vm.gameInfoData.pm10 = findDustData.pm10Value;
  //         vm.gameInfoData.pm25 = findDustData.pm25Value;
  //       });
  //     }
  //   });
  // };

  // vm.setGameInfoResult = function() {
  //   if (!vm.gameInfoData.game_id) {
  //     toastr.error('선택하신 일자에 기록된 정보가 없습니다. 먼저 해당일자를 선택하시거나 경기를 시작해주십시오');
  //     return;
  //   }
  //   $scope.$parent.base.setGameInfo();
  //   // $scope.$parent.base.setGameResult();
  // };

  // // 동영상 생성/수정
  // vm.setMurl = function() {
  //   if (!vm.gameInfoData.game_id) {
  //     toastr.error('선택하신 일자에 기록된 정보가 없습니다. 먼저 해당일자를 선택하시거나 경기를 시작해주십시오');
  //     return;
  //   }

  //   if (!vm.setMurlData.url) {
  //     toastr.error('동영상 URL을 입력해주십시오');
  //     return;
  //   }

  //   if(!vm.setMurlData.title) {
  //     toastr.error('동영상 제목을 입력해주십시오');
  //     return;
  //   }

  //   // 유튜브 동영상의 경우 동영상 url 변경
  //   // 예) https://www.youtube.com/watch?v=aSIkQ8USdWc => https://www.youtube.com/embed/aSIkQ8USdWc
  //   if (vm.setMurlData.url.match('youtube.com')) {
  //     if (!vm.setMurlData.url.match('\/embed\/')) {   // 이미 embed URL 인 경우 제외
  //       let urlId = vm.setMurlData.url.split('=')[1];
  //       vm.setMurlData.url = 'https://www.youtube.com/embed/' + urlId;
  //     }
  //   } else if (vm.setMurlData.url.match('youtu.be')) {  // 예) https://youtu.be/aSIkQ8USdWc
  //     let urlSplitLen = vm.setMurlData.url.split('/').length;
  //     let urlId = vm.setMurlData.url.split('/')[urlSplitLen - 1];
  //     vm.setMurlData.url = 'https://www.youtube.com/embed/' + urlId;
  //   }

  //   let setMurlData = angular.copy(vm.setMurlData);
  //   setMurlData.training_id = null;
  //   PlanService.setMurl(setMurlData).then(function(data) {
  //     if (data.murl_id) {
  //       toastr.success('저장되었습니다.')
  //       vm.setMurlData.title = null;
  //       vm.setMurlData.url = null;
  //       $scope.$parent.base.getGameResult();
  //     }
  //   });
  // };

  // //동영상 삭제
  // vm.viewMediaId = '';
  // vm.removeMurl = function(id) {
  //   vm.removeMurlData.murl_id = id;
  //   PlanService.removeMurl(vm.removeMurlData).then(function(data) {
  //     if(data.result == 'SUC'){
  //       toastr.success('삭제되었습니다.')
  //       vm.setMurlData.title = null;
  //       vm.setMurlData.url = null;
  //       if(vm.viewMediaId == id){
  //         let el = angular.element("#viewMedia");
  //         el.attr('src', '');
  //       }
  //       $scope.$parent.base.getGameResult();
  //     }
  //   });
  // }

  // vm.displayMedia = function(id, url){
  //   // vm.viewMedia = 'https://www.youtube.com/watch?v=ADq3QLntd5Y';
  //   vm.viewMediaId = id;
  //   let el = angular.element("#viewMedia");
  //   el.attr('src', url);
  // }
}

export default {
  name: 'GameCtrl',
  fn: GameCtrl
};
